import { IEditVideoStudioState } from './editVideoStudioModalContext';
import { EditVideoStudioActionTypes, TEditVideoStudioAction } from '../editVideoStudioModalActions';

export const editVideoStudioReducer = (
	state: IEditVideoStudioState,
	action: TEditVideoStudioAction,
): IEditVideoStudioState => {
	switch (action.type) {
		case EditVideoStudioActionTypes.SET_INITIAL_FORM_DATA:
			return {
				...state,
				initialFormData: action.payload.initialFormData,
			};
		case EditVideoStudioActionTypes.SET_ALL_DATA:
			return {
				...state,
				studioID: action.payload.id,
				name: action.payload.name,
			};
		case EditVideoStudioActionTypes.CHANGE_NAME:
			return {
				...state,
				name: action.payload.name,
			};
		case EditVideoStudioActionTypes.SET_DATA_FOR_SUBMIT:
			return {
				...state,
				dataForSubmit: action.payload.dataForSubmit,
			};
		case EditVideoStudioActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case EditVideoStudioActionTypes.RESET_FIELDS:
			return {
				...state,
				name: '',
				dataForSubmit: null,
			};
		default:
			return state;
	}
};
